import {useState} from "../../../__snowpack__/pkg/react.js";
import {createModel} from "../../../__snowpack__/pkg/hox.js";
import {axios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
export const useShopLogisticsList = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const fetchData = async (shopId) => {
    try {
      setLoading(true);
      const {data: data2} = await axios.get(`/shop/logistics-shop/${shopId}`);
      setData(data2);
      return data2;
    } catch (error) {
      handleError(error);
      return data;
    } finally {
      setLoading(false);
    }
  };
  return {
    shopLogisticsListLoading: loading,
    shopLogisticsList: data,
    fetchShopLogisticsList: fetchData
  };
};
export const useShopsLogisticsMap = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [shops, setShops] = useState(void 0);
  const fetchData = async (shopIdList, shopList) => {
    try {
      setLoading(true);
      const resList = await Promise.all(shopIdList.map((_) => {
        return axios.get(`/saas/product/get-product-logistics-options`, {
          params: {
            shopId: _
          }
        });
      }));
      const data2 = resList.reduce((acc, cur, idx) => {
        acc[shopIdList[idx]] = cur.data[0].logisticsList;
        return acc;
      }, {});
      setData(data2);
      setShops(shopList);
      return data2;
    } catch (error) {
      handleError(error);
      return data;
    } finally {
      setLoading(false);
    }
  };
  const updateData = async (channel, shopId) => {
    setLoading(true);
    try {
      const {data: syncSuccess} = await axios.post(`/saas/shop/pull-logistics-by-channel-and-shop`, {
        channel,
        shopId
      });
      if (Boolean(syncSuccess)) {
        const {data: temp} = await axios.get(`/saas/product/get-product-logistics-options`, {
          params: {
            shopId
          }
        });
        const tempData = {
          ...data,
          [shopId]: temp[0].logisticsList
        };
        setData(tempData);
        return data;
      }
    } catch (error) {
      handleError(error);
      return data;
    } finally {
      setLoading(false);
    }
  };
  return {
    shopsLogisticsMapLoading: loading,
    shopsLogisticsMap: data,
    shopsLogisticsShops: shops,
    fetchShopsLogisticsMap: fetchData,
    updateShopsLogisticsMap: updateData
  };
};
export const useShopsLogisticsMapModel = createModel(useShopsLogisticsMap);
